import React, { useState, useEffect } from 'react'
import { skipToken } from '@reduxjs/toolkit/query/react'
import FollowStyle from '../styles/pages/FollowIncidents.module.scss'
import { Link, useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import arrowLeft from '../shared/images/icon-arrow-left.svg'
import { Box, Typography, List, ListItem } from '@mui/material'
import arrow from '../shared/images/arrow-down.svg'
import { RootState } from '../store/GlobalStore'
import { useGetUserIncidentsQuery  } from '../services/IncidentAPI'
import { useTranslation } from 'react-i18next';

const FollowIncidentsPage: React.FC = () => {
    const authState = useSelector((state: RootState) => state.Auth)
    const { t, i18n  } = useTranslation();
     // Ne pas appeler la query si l'utilisateur n'est pas défini
     const userId = authState?.user?.id

     const {
         data: userIncidentData,
         error: userIncidentError,
         isLoading: userIncidentLoading,
         refetch,
     } = useGetUserIncidentsQuery(
         userId ? { userId } : skipToken // Skip la query si userId est null
     )

    const navigate = useNavigate()
    const dispatch = useDispatch()

    useEffect(() => {
        // Appel de refetch lorsque le composant se monte
        if (userId) {
          refetch();
        }
      }, [authState.user, refetch]);

    // Fonction pour obtenir le style de l'indicateur de statut (rouge ou vert)
    const getStatusIndicator = (resolved: boolean) => ({
        backgroundColor: resolved ? 'green' : 'red',
        width: '10px',
        height: '10px',
        borderRadius: '50%',
        display: 'inline-block',
        marginRight: '8px'
    })

    return (
        <div className={FollowStyle.MainContainer}>
            <div className={FollowStyle.TopContainer}>
                <Link to='/mon-compte'>
                    <button className={FollowStyle.arrowButton}>
                        <img src={arrowLeft} alt='Arrow Left' />
                    </button>
                </Link>
                <h2>{t('my_follow')}</h2>
            </div>
            <div>
                <div className={FollowStyle.DesktopFormField}>
                    <Box className={FollowStyle.AccountBox}>
                        <List>
                             {/* Génération dynamique des ListItem à partir de userIncidentData */}
                             {userIncidentLoading && <div>{t('loading') + '...'}</div>}
                            {userIncidentError && <div>Erreur lors de la récupération des incidents</div>}
                            {userIncidentData && userIncidentData.length > 0 ? (
                                 // Trier les incidents : les résolus en dernier
                                [...userIncidentData]
                                .sort((a, b) => (a.resolved === b.resolved ? 0 : a.resolved ? 1 : -1))
                                .map((incident, index) => (
                                    <ListItem
                                        key={index}
                                        className={`${FollowStyle.Button} ${
                                            index !== 0
                                                ? FollowStyle.MiddleIncident
                                                : ''
                                        }`}
                                        component={Link}
                                        to={`/incident/${incident.id}`} // lien vers une page de détail pour chaque incident
                                    >
                                        <div className={FollowStyle.Subtitle}>
                                            {/* Indicateur rond pour le statut */}
                                            <div>{incident.title}</div> {/* Titre de l'incident */}
                                        </div>
                                        <div className={FollowStyle.Status}>
                                            <span style={getStatusIndicator(incident.resolved)}></span>
                                            <span>{incident.resolved ? t('cloture') : t('en_cours') }</span>
                                        </div>
                                        <img src={arrow} alt='arrow' />
                                    </ListItem>
                                ))
                            ) : (
                                <Typography>{t('no_incident')}</Typography>
                            )}
                        </List>
                    </Box>
                </div>
            </div>
        </div>
    )
}

export default FollowIncidentsPage